export const CONVERSATION_STAGE_LABELS = [
  'nunca-respondeu',
  'em-atendimento',
  'enviando-docs',
  'em-repasse',
  'resolvido',
];

export const EMPTY_CONVERSATION_STAGE_ID = '__empty_stage__';
export const EMPTY_CONVERSATION_STAGE_LABEL = 'Status Vazio';

export const CONVERSATION_STAGES = CONVERSATION_STAGE_LABELS.map(label => ({
  id: label,
  name: label,
}));

export const CONVERSATION_STAGE_DESCRIPTION_MARKER = '[orbix-etapa]';
export const CONVERSATION_STAGE_ORDER_MARKER = 'ordem:';

export const LEGACY_CONVERSATION_STAGE_LABEL_MAP = {
  resolver: 'em-atendimento',
  docs: 'enviando-docs',
  'nunca respondeu': 'nunca-respondeu',
  'em atendimento': 'em-atendimento',
  'enviando docs': 'enviando-docs',
  'em repasse': 'em-repasse',
};

export const CONVERSATION_STAGE_AND_LEGACY_LABELS = [
  ...CONVERSATION_STAGE_LABELS,
  ...Object.keys(LEGACY_CONVERSATION_STAGE_LABEL_MAP),
];

export const formatConversationStageLabel = label =>
  label === EMPTY_CONVERSATION_STAGE_ID
    ? EMPTY_CONVERSATION_STAGE_LABEL
    : String(label || '')
        .replace(/[-_]+/g, ' ')
        .split(' ')
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');

export const normalizeConversationStageLabel = label =>
  String(label || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^-\p{L}\p{N}_]/gu, '')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');

export const isConversationStageLabel = label =>
  CONVERSATION_STAGE_LABELS.includes(
    normalizeConversationStageLabel(label?.title || label)
  ) || label?.description?.includes(CONVERSATION_STAGE_DESCRIPTION_MARKER);

export const getConversationStageOrder = label => {
  const defaultIndex = CONVERSATION_STAGE_LABELS.indexOf(
    normalizeConversationStageLabel(label?.title || label)
  );
  const fallback = defaultIndex === -1 ? 999 : defaultIndex;
  const match = label?.description?.match(/ordem:(\d+)/);
  return match ? Number(match[1]) : fallback;
};

export const buildConversationStageDescription = order =>
  `${CONVERSATION_STAGE_DESCRIPTION_MARKER} ${CONVERSATION_STAGE_ORDER_MARKER}${order}`;
